<template>
  <div class="content ht-100v pd-0">
    <div class="content-body ht-100v pd-x-0 pd-y-0 overflow-hidden">
      <div class="content-header bd-b pd-0 gosm-toolbar">
        <div class="navbar navbar-expand-lg wd-100p" style="height: 59px">
          <div class="pd-l-10">Жагсаалт</div>
          <div class="collapse navbar-collapse order-2">
            <div class="mg-l-auto">
              <a
                class="btn btn-sm pd-x-15 btn-primary btn-uppercase text-white"
                @click="editShow"
              >
                <feather type="plus" class="m-r-5"></feather>Шинэ
              </a>
            </div>
          </div>
        </div>
      </div>
      <search ref="srchArea" />
    </div>
  </div>
</template>

<script>
import search from "@/views/apps/ipom/pages/search/index.vue";

export default {
  components: {
    search
  },
  methods: {
    editShow() {
      this.$refs.srchArea.editShow(0);
    }
  }
};
</script>

<style></style>
